/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.insights.rpc.UserInsightsChirpService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type HubSpotProductPlan =
  | 'MARKETING_STARTER'
  | 'MARKETING_BASIC'
  | 'MARKETING_PROFESSIONAL'
  | 'MARKETING_ENTERPRISE'
  | 'SALES_STARTER'
  | 'SALES_PROFESSIONAL'
  | 'SALES_ENTERPRISE'
  | 'SERVICE_STARTER'
  | 'SERVICE_PROFESSIONAL'
  | 'SERVICE_ENTERPRISE'
  | 'CMS_STARTER'
  | 'CMS_PROFESSIONAL'
  | 'CMS_ENTERPRISE'
  | 'OPS_STARTER'
  | 'OPS_PROFESSIONAL'
  | 'OPS_ENTERPRISE'
  | 'CORE_SEATS_STARTER'
  | 'CORE_SEATS_PROFESSIONAL'
  | 'CORE_SEATS_ENTERPRISE'
  | unhandledEnumCase;

export type Country =
  | 'AFGHANISTAN'
  | 'ALAND_ISLANDS'
  | 'ALBANIA'
  | 'ALGERIA'
  | 'AMERICAN_SAMOA'
  | 'ANDORRA'
  | 'ANGOLA'
  | 'ANGUILLA'
  | 'ANTARCTICA'
  | 'ANTIGUA_BARBUDA'
  | 'ARGENTINA'
  | 'ARMENIA'
  | 'ARUBA'
  | 'ASIA_PACIFIC_REGION'
  | 'AUSTRALIA'
  | 'AUSTRIA'
  | 'AZERBAIJAN'
  | 'BAHAMAS'
  | 'BAHRAIN'
  | 'BANGLADESH'
  | 'BARBADOS'
  | 'BELARUS'
  | 'BELGIUM'
  | 'BELIZE'
  | 'BENIN'
  | 'BERMUDA'
  | 'BHUTAN'
  | 'BOLIVIA'
  | 'BOSNIA_HERZEGOVINA'
  | 'BOTSWANA'
  | 'BOUVET_ISLAND'
  | 'BRAZIL'
  | 'BRITISH_INDIAN_OCEAN'
  | 'BRITISH_VIRGIN_ISLANDS'
  | 'BRUNEI'
  | 'BULGARIA'
  | 'BURKINA_FASO'
  | 'BURUNDI'
  | 'CAMBODIA'
  | 'CAMEROON'
  | 'CANADA'
  | 'CAPE_VERDE'
  | 'CARIBBEAN_NETHERLANDS'
  | 'CAYMAN_ISLANDS'
  | 'CENTRAL_AFRICAN_REPUBLIC'
  | 'CHAD'
  | 'CHILE'
  | 'CHINA'
  | 'CHRISTMAS_ISLAND'
  | 'COCOS_KEELING_ISLANDS'
  | 'COLOMBIA'
  | 'COMOROS'
  | 'CONGO'
  | 'COOK_ISLANDS'
  | 'COSTA_RICA'
  | 'COTE_D_IVOIRE'
  | 'CROATIA'
  | 'CUBA'
  | 'CURACAO'
  | 'CYPRUS'
  | 'CZECH_REPUBLIC'
  | 'DEMOCRATIC_REPUBLIC_CONGO'
  | 'DENMARK'
  | 'DJIBOUTI'
  | 'DOMINICA'
  | 'DOMINICAN_REPUBLIC'
  | 'EAST_TIMOR'
  | 'ECUADOR'
  | 'EGYPT'
  | 'EL_SALVADOR'
  | 'EQUATORIAL_GUINEA'
  | 'ERITREA'
  | 'ESTONIA'
  | 'ETHIOPIA'
  | 'EUROPE'
  | 'FALKLAND_ISLANDS'
  | 'FAROE_ISLANDS'
  | 'FIJI'
  | 'FINLAND'
  | 'FRANCE'
  | 'FRENCH_GUIANA'
  | 'FRENCH_POLYNESIA'
  | 'FRENCH_SOUTHERN_AND_ANTARCTIC_LANDS'
  | 'GABON'
  | 'GAMBIA'
  | 'GEORGIA'
  | 'GERMANY'
  | 'GHANA'
  | 'GIBRALTAR'
  | 'GREECE'
  | 'GREENLAND'
  | 'GRENADA'
  | 'GUADELOUPE'
  | 'GUAM'
  | 'GUATEMALA'
  | 'GUERNSEY'
  | 'GUINEA'
  | 'GUINEA_BISSAU'
  | 'GUYANA'
  | 'HAITI'
  | 'HEARD_MCDONALD_ISLANDS'
  | 'HONDURAS'
  | 'HONG_KONG'
  | 'HUNGARY'
  | 'ICELAND'
  | 'INDIA'
  | 'INDONESIA'
  | 'IRAN'
  | 'IRAQ'
  | 'IRELAND'
  | 'ISLE_MAN'
  | 'ISRAEL'
  | 'ITALY'
  | 'JAMAICA'
  | 'JAPAN'
  | 'JERSEY'
  | 'JORDAN'
  | 'KAZAKHSTAN'
  | 'KENYA'
  | 'KIRIBATI'
  | 'KOSOVO'
  | 'KUWAIT'
  | 'KYRGYZSTAN'
  | 'LAOS'
  | 'LATVIA'
  | 'LEBANON'
  | 'LESOTHO'
  | 'LIBERIA'
  | 'LIBYA'
  | 'LIECHTENSTEIN'
  | 'LITHUANIA'
  | 'LUXEMBOURG'
  | 'MACAU'
  | 'MACEDONIA'
  | 'MADAGASCAR'
  | 'MALAWI'
  | 'MALAYSIA'
  | 'MALDIVES'
  | 'MALI'
  | 'MALTA'
  | 'MARSHALL_ISLANDS'
  | 'MARTINIQUE'
  | 'MAURITANIA'
  | 'MAURITIUS'
  | 'MAYOTTE'
  | 'MEXICO'
  | 'MICRONESIA'
  | 'MOLDOVA'
  | 'MONACO'
  | 'MONGOLIA'
  | 'MONTENEGRO'
  | 'MONTSERRAT'
  | 'MOROCCO'
  | 'MOZAMBIQUE'
  | 'MYANMAR_BURMA'
  | 'NAMIBIA'
  | 'NAURU'
  | 'NEPAL'
  | 'NETHERLANDS'
  | 'NETHERLANDS_ANTILLES'
  | 'NEW_CALEDONIA'
  | 'NEW_ZEALAND'
  | 'NICARAGUA'
  | 'NIGER'
  | 'NIGERIA'
  | 'NIUE'
  | 'NORFOLK_ISLAND'
  | 'NORTHERN_MARIANA_ISLANDS'
  | 'NORTH_KOREA'
  | 'NORWAY'
  | 'OMAN'
  | 'PAKISTAN'
  | 'PALAU'
  | 'PALESTINE'
  | 'PANAMA'
  | 'PAPUA_NEW_GUINEA'
  | 'PARAGUAY'
  | 'PERU'
  | 'PHILIPPINES'
  | 'PITCAIRN_ISLANDS'
  | 'POLAND'
  | 'PORTUGAL'
  | 'PUERTO_RICO'
  | 'QATAR'
  | 'REUNION'
  | 'ROMANIA'
  | 'RUSSIA'
  | 'RWANDA'
  | 'SAINT_BARTHELEMY'
  | 'SAINT_HELENA'
  | 'SAINT_KITTS_NEVIS'
  | 'SAINT_LUCIA'
  | 'SAINT_MARTIN'
  | 'SAINT_PIERRE_MIQUELON'
  | 'SAINT_VINCENT_GRENADINES'
  | 'SAMOA'
  | 'SAN_MARINO'
  | 'SAO_TOME_PRINCIPE'
  | 'SAUDI_ARABIA'
  | 'SENEGAL'
  | 'SERBIA'
  | 'SERBIA_MONTENEGRO'
  | 'SEYCHELLES'
  | 'SIERRA_LEONE'
  | 'SINGAPORE'
  | 'SINT_MAARTEN'
  | 'SLOVAKIA'
  | 'SLOVENIA'
  | 'SOLOMON_ISLANDS'
  | 'SOMALIA'
  | 'SOUTH_AFRICA'
  | 'SOUTH_GEORGIA_SANDWICH_ISLANDS'
  | 'SOUTH_KOREA'
  | 'SOUTH_SUDAN'
  | 'SPAIN'
  | 'SRI_LANKA'
  | 'SUDAN'
  | 'SURINAME'
  | 'SVALBARD_JAN_MAYEN'
  | 'SWAZILAND'
  | 'SWEDEN'
  | 'SWITZERLAND'
  | 'SYRIA'
  | 'TAIWAN'
  | 'TAJIKISTAN'
  | 'TANZANIA'
  | 'THAILAND'
  | 'TOGO'
  | 'TOKELAU'
  | 'TONGA'
  | 'TRINIDAD_TOBAGO'
  | 'TUNISIA'
  | 'TURKEY'
  | 'TURKMENISTAN'
  | 'TURKS_CAICOS_ISLANDS'
  | 'TUVALU'
  | 'UGANDA'
  | 'UKRAINE'
  | 'UNITED_ARAB_EMIRATES'
  | 'UNITED_KINGDOM'
  | 'UNITED_STATES'
  | 'UNITED_STATES_MINOR_ISLANDS'
  | 'URUGUAY'
  | 'US_VIRGIN_ISLANDS'
  | 'UZBEKISTAN'
  | 'VANUATU'
  | 'VATICAN_CITY'
  | 'VENEZUELA'
  | 'VIETNAM'
  | 'WALLIS_FUTUNA'
  | 'WESTERN_SAHARA'
  | 'YEMEN'
  | 'ZAMBIA'
  | 'ZIMBABWE'
  | unhandledEnumCase;

export type Industry =
  | 'ARCHITECTURE'
  | 'AUTOMOTIVE_TRANSPORT'
  | 'BANKING_FINANCIAL_SERVICES'
  | 'BUSINESS_SERVICES_GENERAL'
  | 'CONSTRUCTION_RENOVATION'
  | 'CONSULTING_ADVISORY'
  | 'CONSUMER_PRODUCTS'
  | 'CONSUMER_SERVICES'
  | 'DATA_PROCESSING_HOSTING'
  | 'ECOMMERCE'
  | 'EDUCATION'
  | 'ELECTRONICS'
  | 'ENERGY'
  | 'ENTERTAINMENT'
  | 'FINANCE_INSURANCE'
  | 'GOVERNMENT'
  | 'HEALTH'
  | 'HOSPITALITY'
  | 'LEGAL_SERVICES'
  | 'MANUFACTURING'
  | 'MARKETING_SERVICES'
  | 'MEDIA_PUBLISHING'
  | 'MEDICAL_WELLNESS'
  | 'NON_PROFIT'
  | 'OIL_GAS'
  | 'OTHER'
  | 'REAL_ESTATE'
  | 'RECRUITING_STAFFING'
  | 'RETAIL'
  | 'SHIPPING'
  | 'TECHNOLOGY_HARDWARE_STORAGE'
  | 'TECHNOLOGY_SOFTWARE'
  | 'TELECOM_MOBILE_COMMUNICATIONS'
  | 'TOURISM_TRAVEL'
  | 'TRANSPORTATION_STORAGE'
  | 'UTILITIES'
  | 'WASTE_MANAGEMENT'
  | unhandledEnumCase;

export type EmployeeSize =
  | 'RANGE_1'
  | 'RANGE_2_5'
  | 'RANGE_6_10'
  | 'RANGE_11_25'
  | 'RANGE_26_50'
  | 'RANGE_51_200'
  | 'RANGE_201_1000'
  | 'RANGE_1001_10000'
  | 'RANGE_10001_'
  | 'PREFER_NOT_TO_SAY'
  | unhandledEnumCase;

export type PortalInsightsResponse = {
  hqCountry?: Country;
  industry?: Industry;
  employeeSize?: EmployeeSize;
  productPlans: Default<HubSpotProductPlan[]>;
};

export type UserInsightsRequest = {};

export type UserInsightsResponse = {
  ipCountry?: Country;
  portalInsights: PortalInsightsResponse;
};

export type GetUserInsightsRequestType = Requestify<UserInsightsRequest>;
export type GetUserInsightsResponseType = UserInsightsResponse;
export type GetUserInsightsErrorType = EmptyError & HubspotMetadata;
export const getUserInsightsRpc: ChirpAvroRpcDetails<
  GetUserInsightsRequestType,
  GetUserInsightsResponseType,
  GetUserInsightsErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.insights.rpc.UserInsightsChirpService',
  rpcName: 'getUserInsights',
  auth: 'app',
  fingerprint: 'jeQ6C_HiowFlouUxT5My_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
